export default "__VITE_ASSET__CvTxgLWi__"